import { createSelector } from '@reduxjs/toolkit';
import selectAppEnvMap from './selectAppEnvMap';

export default createSelector(selectAppEnvMap, (map) =>
  [map?.localhostComposer?.studioURLOverride, map?.sandbox4?.studioURLOverride].filter(Boolean)
);
